import { Box } from "@mui/material";
import { theme } from "../../theme";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import { useEffect } from "react";

let Font = ReactQuill.Quill.import("formats/font");
Font.whitelist = ["Roboto", "Ubuntu", "Raleway"];
ReactQuill.Quill.register(Font, true);

export const fontSizeArr = ['clamp(10px, 0.9vw, 28px)', 'clamp(13px, 1.1vw, 35px)', 'clamp(16px, 1.7vw, 45px)', 'clamp(20px, 2.4vw, 60px)'];

var Size = ReactQuill.Quill.import('attributors/style/size');
Size.whitelist = fontSizeArr;
ReactQuill.Quill.register(Size, true);

export const TextContent = (props: {
  content: string;
  edit?: boolean;
  height?: string | number;
  width?: string | number;
  multiline?: boolean;
  title?: boolean;
  minimalEditor?: boolean;
  thumbnailSlide?: boolean;
  onValueChanged?: (val: string) => void;
  onSetReady?: () => void;
}) => {
  const { onSetReady } = props;
  useEffect(() => onSetReady && onSetReady(), [onSetReady]);

  if (!props.edit) {
    return (
      <>
        {props.content.split("\n").map((c, i) => (
          <Box
            key={`text-container-typocraphy-${i}`}
            display={"flex"}
            minHeight={theme.spacing(2)}
            height={props.height ? props.height : "100%"}
            width={
              props.width ? props.width : !props.title ? "100%" : undefined
            }
            minWidth={100}
            alignItems={props.title ? "center" : "flex-start"}
            justifyItems={"stretch"}
          >
            <ReactQuill
              key={`text-content-typocraphy-${i}`}
              value={c}
              readOnly
              theme="bubble"
              style={{
                flex: 1,
                overflow:
                  !!props.title || !!props.thumbnailSlide ? "hidden" : "auto",
                width: "100%",
                height: "100%",
                minWidth: 100,
              }}
            />
          </Box>
        ))}
      </>
    );
  } else {
    return (
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: props.title ? "flex-start" : "flex-start",
          alignItems: "stretch",
          height: props.title ? "100%" : `100%`,
          outlineStyle: props.minimalEditor ? "solid" : "none",
          padding: 0,
          outlineWidth: 1,
          outlineColor: theme.palette.divider,
          zIndex: 99,
        }}
      >
        <ReactQuill
          theme={props.title ? "snow" : props.minimalEditor ? "bubble" : "snow"}
          modules={
            props.title
              ? {
                  toolbar: [
                    "bold",
                    "italic",
                    { size: fontSizeArr },
                    "align",
                    { align: "center" },
                    { color: [] },
                    { font: ["Roboto", "Raleway", "Ubuntu"] },
                  ],
                } // Only bold and italic on title.
              : // Normal, large and huge sizes.
                // Left and center alignment.
                {
                  toolbar: [
                    // Most options on body text. No images or videos.
                    "bold",
                    "italic",
                    "underline",
                    "clean",
                    { color: [] },
                    { background: [] },
                    "link",
                    { list: "ordered" },
                    { list: "bullet" },
                    "align",
                    { align: "center" },
                    { align: "right" },
                    { size: fontSizeArr },
                    { font: ["Roboto", "Raleway", "Ubuntu"] },
                  ],
                }
          }
          style={{
            display: "flex",
            flex: props.title ? undefined : 1,
            flexDirection: "column",
            justifyContent: props.title ? "flex-start" : "flex-start",
            alignItems: "stretch",
            height: props.title ? undefined : undefined,
            borderStyle: props.title ? "none" : "solid",
            borderWidth: props.title ? 1 : 1,
            borderColor: theme.palette.divider,
            minWidth: props.minimalEditor ? 200 : 50,
            zIndex: 9,
            //overflow: "auto",
          }}
          value={props.content}
          onChange={props.onValueChanged}
        />
      </Box>
    );
  }
};
